export default "__VITE_ASSET__BojlL$X___"